<script>
    /* Executable code section of the program */
    //Tools importation
    import { isAlertOn,alertMessagge,isReloadNecessary,noSlotsModalOn } from "../../apis/storage";
  
    //Auxiliary varibles
  
    //Function to undisplay alert
    const undisplayModal = () =>{
        console.log("hola");
        
        $noSlotsModalOn = false
    }
  
    /* End of the section */
  </script>
  
  <section class="principalContainer">
    <div class="alertContainer">
        <div class="alertHeader">
            <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            class="bi bi-x-circle icon"
            viewBox="0 0 16 16"
            on:keypress={() => undisplayModal()}
            on:click={() => undisplayModal()}
          >
            <path
              d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
            />
            <path
              d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
            />
          </svg>
        </div>
        <div class="alertContent">
            <p>All possible meetings for this networking break have already been scheduled. Please wait for the next networking break to organize your meeting.</p>
        </div>
        <div class="alertfooter">
            <button class="actionBtn addEventBtn" on:click={() => undisplayModal()}
                >Close</button>
        </div>
    </div>
  </section>
  
  <!-- End of the section -->
  <style>
    /* Section to place the code styles */
    /* Principal Container */
    .principalContainer {
      position: fixed;
      top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 20dvh;
      z-index: 999;
      margin: 80px 0;/* 
      background-color: rgba(0, 0, 0, 0.164); */
    }
    /* Container */
    .alertContainer {
      text-align: center;
      background-color: white;
      width: 50%;
      height: auto;
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 30px;
      border: 1px solid gray;
    }

    /* hearder */
    .alertHeader{
        border-bottom: 1px solid gray;
        display: flex;
        justify-content: flex-end;
        padding: 10px;
        width: 90%;
    }
    .icon:hover{
        color: red;
        cursor: pointer;
    }

    /* Content */
    .alertContent{
        width: 90%;
        padding: 30px 10px;
    }

    /* Footer */
    .alertfooter{
        width: 90%;
        display: flex;
        justify-content: flex-end;
    }
  .actionBtn {
    width: 150px;
    height: 40px;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 5px;
  }

  .addEventBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }

    /* /////////Tablets///////// */
    @media (min-width: 700px) and (max-width: 1100px) {
      .alertContainer{
        width: 80%;
      }
    }
    /* /////////Cellphones ///////// */
    @media (max-width: 700px) {
      .alertContainer{
        width: 100%;
      }
    }
    /* End of the section */
  </style>
  